// extracted by mini-css-extract-plugin
module.exports = {"inner":"SocialProofBanner_inner__JiJEp","imageWrap":"SocialProofBanner_imageWrap__zsfyr","headline":"SocialProofBanner_headline__rfYuG"};